import { ImagePickerInput } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface EventTypeImagePickerProps {
	name: string;
	label?: string;
	required?: boolean;
}

export const EventTypeImagePicker: FC<EventTypeImagePickerProps> = ({ name, label, required = false }) => {
	const { t } = useTranslation();

	return (
		<ImagePickerInput
			label={label || t("Image")}
			name={name}
			cropImageWithAspect={4}
			aspectRatioOptions={[{ name: "4 / 1", aspect: 4 }]}
			canRemoveImage={true}
			required={required}
		/>
	);
};
